
import React, { useState } from 'react';
import { Todo } from '../types';
import TodoItem from './TodoItem';
import { PlusIcon } from './icons/PlusIcon';

interface TodoListProps {
  todos: Todo[];
  onAddTodo: (text: string) => void;
  onToggleTodo: (id: string) => void;
  onDeleteTodo: (id: string) => void;
  title: string;
  isAdmin: boolean;
}

const TodoList: React.FC<TodoListProps> = ({ todos, onAddTodo, onToggleTodo, onDeleteTodo, title, isAdmin }) => {
  const [newTodo, setNewTodo] = useState('');

  const addTodo = () => {
    if (newTodo.trim() === '') return;
    onAddTodo(newTodo);
    setNewTodo('');
  };

  const sortedTodos = [...todos].sort((a, b) => Number(a.isCompleted) - Number(b.isCompleted));
  const completedCount = todos.filter(t => t.isCompleted).length;

  return (
    <div className="flex flex-col min-h-0">
      <p className="text-xs text-medium mb-4">{completedCount} / {todos.length} completed</p>
      {isAdmin && (
        <div className="flex space-x-2 mb-4">
          <input
            type="text"
            name="new-todo"
            value={newTodo}
            onChange={(e) => setNewTodo(e.target.value)}
            onKeyDown={(e) => e.key === 'Enter' && addTodo()}
            placeholder="Add a new task..."
            className="flex-grow bg-white/70 border-slate-300 text-light rounded-md p-2 focus:ring-accent focus:border-accent"
          />
          <button
            onClick={addTodo}
            className="hover:bg-fuchsia-600 text-light hover:text-white p-2 rounded-lg"
            aria-label="Add to-do"
          >
            <PlusIcon className="w-5 h-5" />
          </button>
        </div>
      )}
      <div className="space-y-2 max-h-60 overflow-y-auto pr-2">
        {sortedTodos.map((todo) => (
          <TodoItem
            key={todo.id}
            todo={todo}
            onToggle={() => onToggleTodo(todo.id)}
            onDelete={() => onDeleteTodo(todo.id)}
            isAdmin={isAdmin}
          />
        ))}
      </div>
    </div>
  );
};

export default TodoList;
